const SERVER_HOST = 'https://api.weqayah.co/';

export const request = (href, method, body, headers) => {
  if (method === 'POST')
    body = { ...body, token: JSON.parse(localStorage.getItem('token')) };
  return fetch(`${SERVER_HOST}${href}`, {
    method: method,
    headers: headers ? headers : { 'Content-Type': 'application/json' },
    body: body && JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
};

export const fileRequest = (href, method, body) => {
  return fetch(`${SERVER_HOST}${href}`, {
    method: method,
    body: body,
  })
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
};

export const downloadRequest = async (href, method, show) => {
  try {
    const response = await fetch(`${SERVER_HOST}${href}`, {
      method: method,
    });
    if (show) {
      return await response.blob();
    } else {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = href.split('/').pop();
      a.click();
    }
  } catch (error) {
    console.error(error);
  }
};
